import { acceptHMRUpdate, defineStore, storeToRefs } from 'pinia';
import type { InputSource } from '@/types/InputSource.ts';
import { watch } from 'vue';
import { SYNC_TO_WEB_VIEW_KEYS } from '@/types/sync/SyncKeys.ts';
import { syncToWebViewAction } from '@/actions/sync/SyncToWebViewAction.ts';

interface State {
    sources: InputSource[];
    sourcesLoading: boolean;

    // Source recovery
    lostSourceId: string | null;
    lostSourceName: string | null;
    selectedSourceId: string | null;
    selectedSourceName: string | null;
}

export const useSourceStore = defineStore('v3/source', {
    state: (): State => {
        return {
            sources: [],
            sourcesLoading: false,

            // Source recovery
            lostSourceId: null,
            lostSourceName: null,
            selectedSourceId: null,
            selectedSourceName: null,
        };
    },
    persist: {
        storage: sessionStorage,
    },
});

/**
 * @see storeSyncSourceHandler
 * @see syncStoresToWebViewAction
 */
export const sourceStoreWatcherHandler = (
    sources: InputSource[],
    selectedSourceId: string | null,
    selectedSourceName: string | null,
) => {
    syncToWebViewAction(
        SYNC_TO_WEB_VIEW_KEYS.storeSyncSource,
        JSON.stringify({
            sources: sources,
            selectedSourceId: selectedSourceId,
            selectedSourceName: selectedSourceName,
        }),
    );
};

export const registerSourceStoreWatcher = () => {
    const sourceStore = useSourceStore();
    const { sources, selectedSourceId, selectedSourceName } = storeToRefs(sourceStore);

    watch(
        [sources, selectedSourceId, selectedSourceName],
        async ([newSources, newSelectedSourceId, newSelectedSourceName, ,]) => {
            sourceStoreWatcherHandler(newSources, newSelectedSourceId, newSelectedSourceName);
        },
        { deep: true },
    );
};

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useSourceStore, import.meta.hot));
}
